// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"18534e34","599":"ef67b79c"}[chunkId] + ".chunk.js";
};